export default __webpack_public_path__ + "static/media/5.6cf8b7dc.jpg";